/**
 * The cards a workspace starts with while the real API is still ahead of us.
 *
 * Names, order and dates are the prototype's three cards. `Test 3` ships with
 * **no** application references: the delete-flow requirements are written
 * against it as the deletable card (spec R24, R26, R27), while `Test_Card`
 * carries Guide + Commend as the blocked case (spec R25).
 *
 * References are read-only in this delivery — nothing in the module edits them
 * (the spec scopes "Applied in" editing out).
 */

import { createDefaultCard } from '../state';
import { ProductCard } from '../types';

const seedCard = (
  id: string,
  name: string,
  isoDate: string,
  references: ProductCard['references']
): ProductCard => ({
  ...createDefaultCard(name, `${isoDate}T00:00:00.000Z`, id),
  references,
});

export const createSeedCards = (): ProductCard[] => [
  seedCard('test-card', 'Test_Card', '2026-05-15', ['guide', 'commend']),
  seedCard('test-2', 'Test 2', '2026-05-12', ['commend', 'resolve']),
  seedCard('test-3', 'Test 3', '2026-04-26', []),
];
